import React from 'react';
import Alert from '../assets/images/errorBannerIcon.svg';

export default () => {
    return <img src={Alert} alt="" />;
  };
